import React, { Component } from 'react';
import AppRoutes from './routes.js';
import "./config.js";
import { CssBaseline } from '@mui/material';
import { createTheme,ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  root: {
    '& .MuiTextField-root': {
      margin: 1,
      width: '25ch',
    },
  },
  palette: {
    primary: {
      // light: 这将从 palette.primary.main 中进行计算，
      // main #64b5f6 字体和图标颜色
      main: global.constants.const_color_icon,
      //#64b5f6
      // dark: 这将从 palette.primary.main 中进行计算，
      // contrastText: 这将计算与 palette.primary.main 的对比度
    },
    secondary: {
      light: '#0066ff',
      //main: '#0044ff',
      //灰色
      main: '#808080',
      // dark: 这将从 palette.secondary.main 中进行计算，
      contrastText: '#ffcc00',
    },
    // 使用 `getContrastText()` 来最大化
    // 背景和文本的对比度
    contrastThreshold: 3,
    // 使用下面的函数用于将颜色的亮度在其调色板中
    // 移动大约两个指数。
    // 例如，从红色 500（Red 500）切换到 红色 300（Red 300）或 红色 700（Red 700）。
    tonalOffset: 0.2,
    background:{
      paper: '#ffffff00',
      default: '#ffffff00',
    },
    googler:{
      title: '#0066CC',
      content: '#000000',
    }
  },
  shadows: {
    0:"none",
    1:"none",
    2:"none",
    3:"none",
    4:"none",
    5:"none",
    6:"none",
    7:"none",
    8:"none",
    9:"none",
    10:"none",
    11:"none",
    12:"none",
    13:"none",
    14:"none",
    15:"none",
    16:"none",
    24:"0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
  },
  minis: {
    toolbar:{
      minHeight: 56,
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'large',
        width: 300,
      },
    },
    MuiFilledInput: {
      defaultProps: {
        margin: 'dense',
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: 'dense',
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: 'dense',
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        sizeSmall: {
          // 调整间距，以达到最小的触摸目标命中框。
          marginLeft: 4,
          marginRight: 4,
          padding: 12,
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: 'dense',
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: 'dense',
      },
    },
    MuiListItem: {
      defaultProps: {
        dense: false,
        margin: 'auto',
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        margin: 'dense',
      },
    },
    MuiFab: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTable: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: 'normal',
      },
    },
    MuiToolbar: {
      defaultProps: {
        variant: 'auto',
      },
    },
  },
});

class App extends Component {
  render() {
    return (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppRoutes></AppRoutes>
        </ThemeProvider>
    );
  }
}

export default App;

